/**
 * L'arithmétique de la roue, à part du composant.
 *
 * Un `conic-gradient` part de midi et tourne dans le sens horaire : le secteur `i` occupe
 * `[i × 60°, (i + 1) × 60°[` et son centre est à `i × 60 + 30`. Le repère, lui, est fixe à
 * midi. Amener le centre du secteur `i` sous le repère demande donc de tourner la roue de
 * `−(i × 60 + 30)`.
 *
 * Deux fonctions, inverses l'une de l'autre, et c'est tout le sujet — mais un signe à
 * l'envers ferait tourner la roue dans le mauvais sens sans qu'aucun type ne s'en émeuve.
 */

export const SECTOR_DEGREES = 60;

/** L'angle qui amène le centre du secteur `index` sous le repère. */
export function restingAngle(index: number): number {
  return -(index * SECTOR_DEGREES + SECTOR_DEGREES / 2);
}

/**
 * Le secteur le plus proche du repère, pour un angle quelconque.
 *
 * L'angle peut être négatif ou dépasser un tour : le doigt tourne sans se soucier des
 * bornes, et plusieurs tours d'affilée sont un geste naturel sur une roue.
 */
export function indexFromAngle(angle: number, count: number): number {
  const raw = Math.round((-angle - SECTOR_DEGREES / 2) / SECTOR_DEGREES);
  return ((raw % count) + count) % count;
}
